import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import { useNavigate } from 'react-router-dom';
import { Person, Numbers, VerifiedUser, Save, Transgender, Badge } from '@mui/icons-material';
import { TextField, InputAdornment, Box, Alert, MenuItem } from '@mui/material';

const textFieldStyle = {
    mb: 2.5,
    '& .MuiOutlinedInput-root': {
        borderRadius: '15px',
        backgroundColor: '#fff',
        '& fieldset': {
            borderColor: 'rgba(0, 0, 0, 0.1)',
        },
        '&:hover fieldset': {
            borderColor: 'rgba(0,0,0,0.2)',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#007bff',
        },
    }
};

const CompleteProfile = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        medicalSystemNumber: '',
        birthdate: '',
        nationalityCode: '',
        sex: '',
        title: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const userStr = localStorage.getItem('user');
        if (!userStr) {
            navigate('/login');
            return;
        }
        const user = JSON.parse(userStr);
        setFormData({
            firstName: user.firstName || '',
            lastName: user.lastName || '',
            medicalSystemNumber: user.medicalSystemNumber || '',
            birthdate: user.birthdate || '',
            nationalityCode: user.nationalityCode || '',
            sex: user.sex || '',
            title: user.title || ''
        });
    }, [navigate]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            await api.patch('/users/me', formData);
            
            // Update local storage user data
            const userStr = localStorage.getItem('user');
            const user = JSON.parse(userStr);
            const updatedUser = { ...user, ...formData };
            localStorage.setItem('user', JSON.stringify(updatedUser));
            
            window.location.replace('/');
        } catch (err) {
            setError(err.response?.data?.message || 'خطا در بروزرسانی اطلاعات');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="main-container container">
            <div className="row mb-4">
                <div className="col-12 col-md-6 mx-auto">
                    <h1 className="mb-4 text-center">تکمیل اطلاعات فردی</h1>
                    <p className="text-secondary mb-4 text-center">لطفا اطلاعات زیر را برای ادامه تکمیل کنید</p>

                    {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}

                    <form onSubmit={handleSubmit}>
                        <TextField
                            fullWidth
                            label="نام"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleChange}
                            required
                            sx={textFieldStyle}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Person color="action" />
                                    </InputAdornment>
                                ),
                            }}
                        />

                        <TextField
                            fullWidth
                            label="نام خانوادگی"
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleChange}
                            required
                            sx={textFieldStyle}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Person color="action" />
                                    </InputAdornment>
                                ),
                            }}
                        />

                        <TextField
                            fullWidth
                            label="کد ملی"
                            name="nationalityCode"
                            value={formData.nationalityCode}
                            onChange={handleChange}
                            required
                            sx={textFieldStyle}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <VerifiedUser color="action" />
                                    </InputAdornment>
                                ),
                            }}
                        />

                        <TextField
                            fullWidth
                            label="شماره نظام پزشکی"
                            name="medicalSystemNumber"
                            value={formData.medicalSystemNumber}
                            onChange={handleChange}
                            sx={textFieldStyle}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Numbers color="action" />
                                    </InputAdornment>
                                ),
                            }}
                        />

                        <TextField
                            fullWidth
                            name="birthdate"
                            label="تاریخ تولد"
                            value={formData.birthdate}
                            onChange={handleChange}
                            placeholder="1370/01/01"
                            sx={textFieldStyle}
                        />

                        <TextField
                            fullWidth
                            select
                            label="جنسیت"
                            name="sex"
                            value={formData.sex}
                            onChange={handleChange}
                            sx={textFieldStyle}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Transgender color="action" />
                                    </InputAdornment>
                                ),
                            }}
                        >
                            <MenuItem value="0">انتخاب جنسیت</MenuItem>
                            <MenuItem value="2">مرد</MenuItem>
                            <MenuItem value="1">زن</MenuItem>
                            <MenuItem value="3">سایر</MenuItem>
                        </TextField>

                        <TextField
                            fullWidth
                            label="عنوان (پروفسور، دکتر، ...)"
                            name="title"
                            value={formData.title}
                            onChange={handleChange}
                            sx={textFieldStyle}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Badge color="action" />
                                    </InputAdornment>
                                ),
                            }}
                        />

                        <button type="submit" className="btn btn-lg btn-default w-100 shadow mt-3" disabled={loading}>
                            <Save sx={{ fontSize: 20, verticalAlign: 'middle' }} className="me-2" /> {loading ? 'در حال ذخیره...' : 'ذخیره و ادامه'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};


export default CompleteProfile;
